import { useQuery } from '@tanstack/react-query';
import { NEWS_KEYS, newsService } from '../service/news.service';


const STALE_TIME = 5 * 60 * 1000; 

export const useNewsFeed = (page: number = 1, limit: number = 6, newsType?: string) => {
    return useQuery({
        queryKey: [...NEWS_KEYS.feed(page), limit, newsType], 
        queryFn: () => newsService.getNewsFeed({ page, limit, newsType }),
        staleTime: 5 * 60 * 1000,
        placeholderData: (previousData) => previousData,
    });
};

export const useSingleNews = (id: number) => {
    return useQuery({
        queryKey: NEWS_KEYS.detail(id),
        queryFn: () => newsService.getSingleNews(id),
        staleTime: STALE_TIME,
        enabled: !!id, 
    });
};

export const useGetNewsTypes = () => {
  return useQuery({
    queryKey: NEWS_KEYS.types,
    queryFn: () => newsService.getNewsTypes(),
    staleTime: 10 * 60 * 1000, 
  });
};